import React, { useState } from "react";
import { withAuthenticationRequired, useAuth0 } from "@auth0/auth0-react";
import { useHistory, useParams } from "react-router-dom";
import { Button, Card, CardBody, CardHeader, Form, FormGroup, Label, Input, Alert } from "reactstrap";
import Loading from "../../components/Loading";
import { createPointConfig } from "../../utils/apiService";

const CreatePointConfigComponent = () => {
  const { brandId, productId } = useParams();
  const history = useHistory();
  const { getAccessTokenSilently } = useAuth0();

  const [form, setForm] = useState({ name: "", value: "" });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      const token = await getAccessTokenSilently().catch(() => null);
      await createPointConfig({
        name: form.name,
        value: parseInt(form.value, 10) || 0,
        productId: parseInt(productId, 10),
        brandId: parseInt(brandId, 10),
      }, token);
      history.push(`/brands/${brandId}/products/${productId}/configs`);
    } catch (err) {
      setError(err?.message || "Failed to create point config");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      <div className="mb-3">
        <Button color="link" className="p-0 me-1" onClick={() => history.push('/brands')}>Brands</Button>
        <span className="text-muted"> &gt; </span>
        <Button color="link" className="p-0 mx-1" onClick={() => history.push(`/brands/${brandId}/products`)}>Products</Button>
        <span className="text-muted"> &gt; </span>
        <Button color="link" className="p-0 mx-1" onClick={() => history.push(`/brands/${brandId}/products/${productId}/configs`)}>Point Configs</Button>
        <span className="text-muted"> &gt; Create</span>
      </div>
      <Card>
        <CardHeader><h1 className="mb-0">Add Point Config</h1></CardHeader>
        <CardBody>
          {error && <Alert color="danger">{error}</Alert>}
          <Form onSubmit={onSubmit}>
            <FormGroup>
              <Label for="configName">Name</Label>
              <Input id="configName" name="name" value={form.name} onChange={onChange} required />
            </FormGroup>
            <FormGroup>
              <Label for="configValue">Point Value</Label>
              <Input id="configValue" name="value" type="number" min="0" value={form.value} onChange={onChange} required />
            </FormGroup>
            <div className="d-flex">
              <Button color="secondary" className="me-2" type="button" onClick={() => history.push(`/brands/${brandId}/products/${productId}/configs`)} disabled={submitting}>
                Cancel
              </Button>
              <Button color="primary" type="submit" disabled={submitting}>
                {submitting ? 'Creating...' : 'Create Point Config'}
              </Button>
            </div>
          </Form>
        </CardBody>
      </Card>
    </div>
  );
};

export default withAuthenticationRequired(CreatePointConfigComponent, {
  onRedirecting: () => <Loading />,
});
